export type AuthShellVariant = "quote_flow" | "classic";

/** Which chrome the auth screens wear. The quote-flow shell is behind the
 * `auth-restyle` flag, except on login-grant screens, which always use it
 * so the lead flow never depends on the flag. */
export function authShellVariant(
  restyleFlag: boolean | undefined,
  loginGrant: string | null | undefined,
): AuthShellVariant {
  if (loginGrant) return "quote_flow";
  return restyleFlag === true ? "quote_flow" : "classic";
}

/** Splits a one-line screen title into the quote-flow heading's serif lead
 * and bold tail: everything before the last word, then the last word. */
export function splitTitle(title: string): { titleA: string; titleB: string } {
  const trimmed = title.trim();
  const cut = trimmed.lastIndexOf(" ");
  if (cut === -1) return { titleA: "", titleB: trimmed };
  return {
    titleA: trimmed.slice(0, cut),
    titleB: trimmed.slice(cut + 1),
  };
}
